import { FormState, RunButtonState, Script, ScriptType } from '../types';
import styles from '../ScriptEditor.module.scss';

export const getScriptTypeName = (type: ScriptType) => {
  switch (type) {
    case ScriptType.Transformation:
      return 'Transformation';
    case ScriptType.Query:
      return 'Query';
    default:
      return 'Unknown';
  }
};

export const formatDate = (dateStr: string | null) => {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleString();
  } catch {
    return dateStr;
  }
};

export const getConsoleLogClassName = (line: string) => {
  if (line.includes('Error:')) {
    return styles.consoleTextError;
  }
  if (line.includes('Info:')) {
    return styles.consoleTextInfo;
  }
  if (line.includes('Debug:')) {
    return styles.consoleTextDebug;
  }
};

export const getRunButtonColor = (value: RunButtonState) => {
  switch (value) {
    case RunButtonState.Success:
      return 'primary';
    case RunButtonState.Error:
      return 'secondary';
    default:
      return 'default';
  }
};

export const scriptToForm = (script: Script): FormState => ({
  name: script.name,
  description: script.description || '',
  javascriptCode: script.javascriptCode || '',
  sampleData: script.sampleData ?? '{}',
  endpointTypeId: script.endpointTypeId,
  endpointSubtypeIds: script.endpointSubtypeIds ?? [],
  inputTypeId: script.inputTypeId,
});
